<script setup lang="ts">

import { ref } from "vue";

defineProps<{ number: Number }>();
const isExpanded = ref( false );

</script>

<template>

    <div class="group cursor-pointer
                transition-colors duration-150 ease-in"
         :class="{ 'bg-gray-800': isExpanded }">

        <div class="px-4 lg:px-6"
             :class="{ 'group-first:border-t-0': isExpanded == false }">
            <div class="py-2 lg:py-3"
                 @click="isExpanded = !isExpanded">
                <div class="text-sm lg:text-base 3xl:text-lg w-full
                            flex items-center justify-start gap-4">
                    <div class="pr-2">{{ number }}</div>
                    <div class="flex flex-col flex-1">
                        <h1 class="flex-1">
                            <slot name="title"></slot>
                        </h1>
                    </div>
                    <div class="-mr-2 flex items-center !p-0">
                        <ExpandButton v-model="isExpanded" 
                                      class="text-2xl pointer-events-none" />
                    </div>
                </div>
            </div>
        </div>

        <!-- ITEMS GROUP -->
        <div v-if="isExpanded"
             class="px-4 lg:px-6 pt-2 pb-5 transition-colors duration-150 ease-in">
            <slot name="content">
            </slot>
        </div>
    
    </div>
    
</template>